import { _getTime } from "./support";
var strEmpty = "";
export function _createAiEnvelope(iKey, theType, sv, version, locn) {
    var tags = {};
    var type = "Browser";
    var strAiDevice = "ai.device.";
    var strAiOperationName = "ai.operation.name";
    var strAiSdkVersion = "ai.internal.sdkVersion";
    var strToLowerCase = "toLowerCase";
    tags[strAiDevice + "id"] = type[strToLowerCase]();
    tags[strAiDevice + "type"] = type;
    tags[strAiOperationName] = locn && locn.pathname || "_unknown_";
    tags[strAiSdkVersion] = "javascript:snippet_" + (sv || version);
    var envelope = {
        time: _getTime(),
        iKey: iKey,
        name: "Microsoft.ApplicationInsights." + iKey.replace(/-/g, strEmpty) + "." + theType,
        sampleRate: 100,
        tags: tags,
        data: {
            baseData: {
                ver: 2
            }
        },
        ver: undefined,
        seq: "1",
        aiDataContract: undefined
    };
    return envelope;
}
var track = "track";
var trackPage = "TrackPage";
var trackEvent = "TrackEvent";
export var aiMethod = [
    track + "Event",
    track + "Exception",
    track + "PageView",
    track + "PageViewPerformance",
    "addTelemetryInitializer",
    track + "Trace",
    track + "DependencyData",
    track + "Metric",
    "start" + trackPage,
    "stop" + trackPage,
    "start" + trackEvent,
    "stop" + trackEvent,
    "setAuthenticatedUserContext",
    "clearAuthenticatedUserContext",
    "flush"
];
